import { Header, Text, VStack } from '@rbilabs/universal-components';

import Picture from 'components/picture';

export const CallToActionHeaderContainer = VStack;

export const CallToActionHeading = Header.withConfig({
  variant: 'headerTwo',
  textAlign: 'center',
  marginTop: '$4',
});

export const CallToActionSubheading = Header.withConfig({
  variant: 'headerThree',
  textAlign: 'center',
  color: Styles.color.primary,
  fontWeight: 'normal',
});

export const CallToActionBody = Text.withConfig({
  marginBottom: '$8',
});

export const Image = Picture.withConfig({
  width: '66%',
  objectFitContain: true,
  marginX: 'auto',
});

export const CallsToAction = VStack.withConfig({
  width: '90%',
  maxWidth: '920px',
  marginTop: '0',
  marginX: 'auto',
  space: '$16',
  marginBottom: '$16',
});

export const CallToAction = VStack.withConfig({
  width: '100%',
});
